import { History } from "history";
import { routerMiddleware, routerReducer } from "react-router-redux";
import { applyMiddleware, combineReducers, compose, createStore, GenericStoreEnhancer, ReducersMapObject, Store, StoreEnhancerStoreCreator } from "redux";
import thunk from "redux-thunk";
import { GoogleAnalyticsMiddleware } from "./middleware";
import { AppState, reducers } from "../src/store";

export function configureStore(history: History, initialState?: AppState) {
    // Build middleware. These are functions that can process the actions before they reach the store.
    const windowIfDefined = typeof window === "undefined" ? null : window as any;
    // If devTools is installed, connect to it
    const devToolsExtension = windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__ as () => GenericStoreEnhancer;
    const createStoreWithMiddleware = compose(
        applyMiddleware(thunk, routerMiddleware(history), GoogleAnalyticsMiddleware),
        devToolsExtension ? devToolsExtension() : <S>(next: StoreEnhancerStoreCreator<S>) => next,
    )(createStore) as (reducers: any, initialState: AppState | undefined) => Store<AppState>;

    // Combine all reducers and instantiate the app-wide store instance
    const allReducers = buildRootReducer(reducers);

    const store = createStoreWithMiddleware(allReducers, initialState) as Store<AppState>;

    return store;
}

function buildRootReducer(allReducers: ReducersMapObject) {
    return combineReducers<AppState>(Object.assign({}, allReducers, { router: routerReducer }));
}



// WEBPACK FOOTER //
// ./src/configure-store.ts